<button mat-flat-button class="metallic-text-btn-clear" type="button" (click)="openBookingRequest()">
    RESERVE
    <i class="fa-solid fa-comment-dots"></i>
</button>